<ng-container *ngIf="!isLoading; else loadingBlock">
 <div class="noPrint" style="display: flex; justify-content: flex-end; gap: 1rem; margin-bottom: 1rem;">
    <button
      [printStyle]="{
        table: { 'border-collapse': 'collapse', width: '100%' },
        td: { border: 'solid 1px', 'font-size': '14px', 'text-align': 'center' },
        th: { border: 'solid 1px', 'font-size': '16px', 'font-weight': '600', 'text-align': 'center' }
      }"
      mat-raised-button
      color="primary"
      printSectionId="print-section"
      ngxPrint>
      Print
    </button>

    <button (click)="exportExcel('Prantwise_Subscription_Report')" mat-raised-button color="primary">
      Export
    </button>

    <button mat-dialog-close mat-raised-button color="warn">
      Close
    </button>
  </div>
  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <div *ngIf="!errorMessage">
    <!-- <div style="margin-left: 70%; margin-top: -4%; margin-bottom: 2%">
      <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        (click)="printPageA4Portrait()">
        print
      </button>
      <button class="noPrint" style="margin-top: 2% 2% 0 2%;"
        (click)="exportexcel('Prant_Districtwise_Subscription_Report')" mat-raised-button color="primary">
        Export
      </button>
      <button mat-dialog-close class="btn noPrint">
        Close
      </button>
    </div> -->

    <div class="container" id="print-section">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th colspan="5">दि {{ endDate | date:"dd/MM/yyyy" }} च्या अंकाकरिता</th>
          </tr>
          <tr>
            <th>अनु क्र.</th>
            <th>जिल्हा</th>
            <th>प्रती</th>
            <th>जमा</th>
            <th>येणे</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let prant of prants">
            <tr class="prant-header">
              <td colspan="5"><strong>{{ prant.prant_name }}</strong></td>
            </tr>
            <tr *ngFor="let district of prant.districts; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ district.district_name }}</td>
              <td>{{ district.issue_copies }}</td>
              <td>{{ district.entry_amount | number:'1.0-2' }}</td>
              <td>{{ district.remaining_amount | number:'1.0-2' }}</td>
            </tr>
            <tr class="prant-total">
              <td></td>
              <td>{{ prant.prant_name }} एकूण</td>
              <td>{{ prant.total.issue_copies }}</td>
              <td>{{ prant.total.entry_amount | number:'1.0-2' }}</td>
              <td>{{ prant.total.remaining_amount | number:'1.0-2' }}</td>
            </tr>
          </ng-container>

          <tr class="grand-total">
            <td></td>
            <td>एकूण बेरीज</td>
            <td>{{ grandTotal.issue_copies }}</td>
            <td>{{ grandTotal.entry_amount | number:'1.0-2' }}</td>
            <td>{{ grandTotal.remaining_amount | number:'1.0-2' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>

<ng-template #loadingBlock>
  <div class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
  </div>
</ng-template>